module.exports = __webpack_public_path__ + "img/double_sword.f62796f2.png";